import React from 'react'
import { serverForImages } from '../../config'
import { useRouter } from 'next/router'

interface IImageItemProps {
  url: string
  title: string
}

const ImageItem: React.FC<IImageItemProps> = ({ url, title }) => {
  const { pathname } = useRouter();

  return (
    <figure className='h-full'>
      <picture
        key={url}
        className='overflow-hidden flex relative h-full'
      >
        <source srcSet={`${serverForImages}${url}`} type='image/webp' />
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className={`h-full w-max m-auto absolute inset-0 object-scale-down ${pathname === '/' ? 'object-top' : ''}`}
          src={`${serverForImages}${url}`}
          alt={title}
          title={title}
        />
      </picture>
    </figure>
  )
}

export default ImageItem
